import React from 'react';
import { TextInput } from 'mintel-react-ui';

import useTranslation from '../translations';
import { handleEmailSubmit } from '../shared/utils';
import { StringField } from '../fields';
import HiddenFields from './HiddenFields';

export interface EmailInputProps {
  fields: { email: StringField; csrf: StringField };
  email: string;
  error: string | null;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
}

export const EmailInputWrapper = ({
  fields,
  email,
  error,
  setEmail,
  setError,
}: EmailInputProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div>
      <TextInput
        id={fields.email.id}
        name={fields.email.name}
        showLabel
        showClear={false}
        label={t('Email Address')}
        value={email}
        placeholder={t('Enter your email address')}
        showIcon={false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setEmail(e.target.value);
        }}
        onSubmit={(e: React.SyntheticEvent) => {
          handleEmailSubmit(e, email, t, setError);
        }}
        error={error}
      />
      <HiddenFields fields={fields} />
    </div>
  );
};

export default EmailInputWrapper;
